import { css } from '@emotion/core';
import styled from '@emotion/styled';

interface ITab extends React.ComponentPropsWithoutRef<'div'> {
    active?: boolean;
}

export const AgendaWrapper = styled.div`
    background: white;
    padding: 10px 32px 32px 32px;
`;
AgendaWrapper.displayName = 'AgendaWrapper';

export const TabsArea = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
`;
TabsArea.displayName = 'TabsArea';

export const TabItem = styled.div<ITab>`
    box-sizing: border-box;
    padding: 8px 16px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    margin-right: 4px;
    background-color: transparent;
    color: #6f7287;
    ${({ active }) =>
        active &&
        css`
            color: #fff;
            background-color: #3659e3;
            border-radius: 28px;
        `}
`;
TabItem.displayName = 'TabItem';
